'use strict'

import { request } from '../../plugins/http'

export default async (data) => {
    return await request.put('/pedido/updateDeadline', data)
}